import useTranslation from 'next-translate/useTranslation';
import { WrapComponentVisibility } from 'src/themes/shared/containers/WrapComponentVisibility';
import { ComponentsName } from 'src/interfaces/enums';
import IconButton from '../IconButton';
import { NotesIcon } from '../../icons';
import TooltipWrapper from '../TooltipWrapper';

export interface INotesOpenButtonProps {
  onClick: () => void;
  className?: string;
}

const NotesOpenButton = ({ onClick, className }: INotesOpenButtonProps) => {
  const { t } = useTranslation('common');
  const tooltipText = t('tooltips.personal_notes');
  const ariaLabel = t('aria_labels.controls.personal_notes');

  return (
    <WrapComponentVisibility componentName={ComponentsName.personalNotes}>
      <TooltipWrapper tooltipText={tooltipText} tooltipPosition='left'>
        <IconButton
          data-testid='notes-open-button'
          aria-label={ariaLabel}
          className={className}
          onClick={onClick}
          icon={<NotesIcon />}
        />
      </TooltipWrapper>
    </WrapComponentVisibility>
  );
};

export default NotesOpenButton;
